import type { PeriodDto, PeriodInputDto, PeriodPagedRequestDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class PeriodService {
  apiName = 'Default';
  

  createByInput = (input: PeriodInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/period',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  deleteByPeriodId = (periodId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/app/period',
      params: { periodId },
    },
    { apiName: this.apiName,...config });
  

  editByInput = (input: PeriodInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/period/edit',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  getAllByInput = (input: PeriodPagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PeriodDto>>({
      method: 'GET',
      url: '/api/app/period',
      params: { name: input.name, dateFrom: input.dateFrom, dateTo: input.dateTo, serviceTypeId: input.serviceTypeId, state: input.state, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getByIdByPeriodId = (periodId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PeriodDto>({
      method: 'GET',
      url: `/api/app/period/by-id/${periodId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
